import { Dialog } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import React from 'react';
import EditExternalBillingItemDtoForm from './EditExternalBillingItemDtoForm';
import { ExternalBillingItemDto } from './types';

interface Props {
    agreementNumber: number;
    addonName: string;
    data?: ExternalBillingItemDto;
    onClose: () => void;
    onSubmitted: () => void;
}

export default function CreateOrEditWebhookDialog({ agreementNumber, addonName, data, onClose, onSubmitted }: Props) {
    if (data) {
        data.agreementNumber = agreementNumber;
    }

    return (
        <Dialog defaultOpen onClose={onClose} draggable size="md">
            <Dialog.Content aria-label={t`${addonName} module edit`}>
                <Dialog.Title>
                    <Trans>{addonName} module edit</Trans>
                </Dialog.Title>
                <EditExternalBillingItemDtoForm data={data} onClose={onClose} onSubmitted={onSubmitted} />
            </Dialog.Content>
        </Dialog>
    );
}
